import { apiClient } from '@/api/client';
import type { Comment } from '@/types/comment';
import type { Paginated } from '@/types/pagination';
import { mapCommentWireToDomain, mapPaginatedCommentsWireToDomain } from '../mappers/comment';
import {
  commentWireSchema,
  paginatedCommentsResponseWireSchema,
  type CommentWire,
  type PaginatedCommentsResponseWire,
} from '../schemas/comment';

/**
 * Get comments for a check-in
 * Calls GET /api/feed/{checkInId}/comments
 */
export async function getComments(
  checkInId: string,
  page: number = 1
): Promise<Paginated<Comment>> {
  const wireData = await apiClient.get<PaginatedCommentsResponseWire>(
    `/api/feed/${checkInId}/comments?page=${page}`
  );
  const validated = paginatedCommentsResponseWireSchema.parse(wireData);
  return mapPaginatedCommentsWireToDomain(validated);
}

/**
 * Create a comment on a check-in
 * Calls POST /api/feed/{checkInId}/comments
 */
export async function createComment(
  checkInId: string,
  content: string
): Promise<Comment> {
  const wireData = await apiClient.post<CommentWire>(
    `/api/feed/${checkInId}/comments`,
    { content }
  );
  const validated = commentWireSchema.parse(wireData);
  return mapCommentWireToDomain(validated);
}

/**
 * Delete a comment
 * Calls DELETE /api/feed/comments/{commentId}
 */
export async function deleteComment(commentId: string): Promise<void> {
  await apiClient.delete(`/api/feed/comments/${commentId}`);
}
